<template>
  <div>
    <div style="background-color: #fff;">
      <v-parallax
              dark
              height="100vh"
              class="mt-7"
      >
        <v-row
                align="center"
                justify="center">
          <v-col cols="1"/>
          <v-col class="text-center" cols="10" md="4">
            <h1 class="display-1 font-weight-thin mb-4">Investing in real-estate?</h1>
            <h4 class="subheading">Check if you picked the right property. Our smart tools help you make sound financial decisions.</h4>
            <v-btn x-large color="primary" class="mt-6" v-if="this.authenticated" @click="dashboard">Launch Dashboard</v-btn>
            <v-btn x-large color="primary" class="mt-6" v-else @click="startNow">Start now</v-btn>
          </v-col>
          <v-col cols="1"/>
          <v-col cols="12" md="6">
            <v-img class="parallax-img" src="@/assets/home-page.svg"/>
          </v-col>
        </v-row>
        <v-spacer v-if="$vuetify.breakpoint.mobile"/>
      </v-parallax>
    </div>
    <div>
      <v-parallax
              height="100vh"
              style="background-color:#e7e4e4;">
        <v-row
                align="center"
                justify="center">
          <v-col cols="12" md="6">
            <v-img class="parallax-img" src="@/assets/prop-comp.png"/>
          </v-col>
          <v-col cols="0" md="1"/>
          <v-col class="text-center" cols="12" md="4">
            <h1 class="display-1 font-weight-thin mb-4">Enter Your Property Information:</h1>
            <h4 class="subheading">Enter the information, and answer few simple questions about the location of your “possible” property.</h4>
          </v-col>
          <v-col cols="0" md="1"/>
        </v-row>
      </v-parallax>
    </div>

    <div style="background-color: #fff;">
      <v-parallax
              dark
              height="100vh"
      >
        <v-row
                align="center"
                justify="center">
          <v-col cols="1"/>
          <v-col class="text-center" cols="10" md="4">
            <h1 class="display-1 font-weight-thin mb-4">Make data-driven decisions</h1>
            <h4 class="subheading">Our tools will crunch the numbers for you and provide necessary data to make informed decisions.</h4>
          </v-col>
          <v-col cols="1"/>
          <v-col cols="12" md="6">
            <v-img class="parallax-img" src="@/assets/home-comps.png"/>
          </v-col>
        </v-row>
        <v-spacer v-if="$vuetify.breakpoint.mobile"/>
      </v-parallax>
    </div>
    <AddProperty :show="showAddPropertyDialog" @cancelled="showAddPropertyDialog=false"></AddProperty>
  </div>
</template>
<script>
  import router from "../router";
  import { authService } from '../services/AuthService';
  import AddProperty from '../components/AddProperty';

  export default {
    components: {
      AddProperty
    },
    data: function() {
      return  {
        authService: authService,
        showAddPropertyDialog: false
      }
    },
    computed: {
      authenticated: {
        get: function () {
          return this.authService && this.authService.userId;
        }
      }
    },
    methods: {
      startNow: function () {
        this.showAddPropertyDialog = true;
      },
      dashboard: function () {
        router.replace({ name: 'Listings'});
      }
    }
  }
</script>

<style>
  .display-1 {
    font-family: Roboto Slab;
    font-style: normal;
    font-weight: normal;
    font-size: 56px;
    line-height: 74px;

    color: #000000;
  }

  .subheading {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 140.62%;
    color: #000000;
  }

  .parallax-img {
    max-height: 400px;
    width: 400px;
    margin: auto;
  }
</style>
